module.exports = __webpack_public_path__ + "static/fonts/Arita-buriSB.4d765f9.otf";